export const shortenUrl = (url, maximumCharactersInUrl) => {
  const { pathname } = new URL(url)

  if (!pathname) return url
  return pathname.length > maximumCharactersInUrl
    ? `${pathname.substr(0, maximumCharactersInUrl)}...`
    : pathname
}
